import React from "react";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import "./footer.css";

const footer = () => {
  return (
    <footer
      className="jupiterx-footer"
      role="contentinfo"
      itemScope="itemscope"
      itemType="http://schema.org/WPFooter"
    >
      {" "}
      <div
        data-elementor-type="footer"
        data-elementor-id="84"
        className="elementor elementor-84 elementor-location-footer"
        data-elementor-post-type="elementor_library"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-b4a93d9 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="b4a93d9"
          data-element_type="section"
          id="footer-top"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-no">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-600a1c0"
              data-id="600a1c0"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-c1b907f elementor-widget elementor-widget-html"
                  data-id="c1b907f"
                  data-element_type="widget"
                  data-widget_type="html.default"
                >
                  <div className="elementor-widget-container">
                    <div className="fpopup-block">
                      <img
                        src="https://haiico.com/wp-content/uploads/2022/12/F-element-1.png"
                        width="320"
                        height="180"
                        id="felement-01"
                      />
                      <img
                        src="https://haiico.com/wp-content/uploads/2022/12/F-element-2.png"
                        width="320"
                        height="180"
                        id="felement-02"
                      />
                    </div>
                    <img
                      src="https://haiico.com/wp-content/uploads/2022/12/F-divider-red.png"
                      width="1920"
                      height="160"
                      id="f-divider"
                      style={{pointerEvents: "none"}}
                    />{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-72232d29 elementor-section-height-min-height elementor-section-full_width elementor-section-height-default elementor-section-items-middle"
          data-id="72232d29"
          data-element_type="section"
          id="footer-content"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-9d3ad1b"
              data-id="9d3ad1b"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-7c676d97 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="7c676d97"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-180d16ea"
                      data-id="180d16ea"
                      data-element_type="column"
                      id="fcol-info"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-86389a3 elementor-widget elementor-widget-html"
                          data-id="86389a3"
                          data-element_type="widget"
                          data-widget_type="html.default"
                        >
                          <div className="elementor-widget-container">
                            <a href="https://haiico.com/">
                              <img
                                src="https://haiico.com/wp-content/uploads/2022/12/Logo-HAiiCO-white.svg"
                                width="150"
                                height="60"
                                id="flogo"
                              />
                            </a>
                            <p className="fc-white">
                              <strong className="strong-class">HAi!CO</strong>{" "}
                              is a Loyalty Program App and it serves as a
                              Platform-As-A-Service for customers and merchants.
                              We empower businesses to execute their loyalty
                              strategy to grow long-term customer relationships,
                              using our proven customer loyalty program.
                            </p>
                            <div className="fdownload-block">
                              <a
                                href="https://apps.apple.com/my/app/id552289119"
                                target="_blank"
                              >
                                <img
                                  src="https://haiico.com/wp-content/uploads/2022/12/icon-app-store.svg"
                                  width="150"
                                  height="45"
                                />
                              </a>
                              <a
                                href="https://play.google.com/store/apps/details?id=com.cardsys.lms.mobile"
                                target="_blank"
                              >
                                <img
                                  src="https://haiico.com/wp-content/uploads/2022/12/icon-google-play.svg"
                                  width="150"
                                  height="45"
                                />
                              </a>
                              <a
                                href="https://appgallery.huawei.com/app/C102646837"
                                target="_blank"
                              >
                                <img
                                  src="https://haiico.com/wp-content/uploads/2022/12/icon-app-gallery.svg"
                                  width="150"
                                  height="45"
                                />
                              </a>
                            </div>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-a3d25aa"
                      data-id="a3d25aa"
                      data-element_type="column"
                      id="fcol-menu"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-1e376d4f elementor-mobile-align-center elementor-align-left elementor-widget elementor-widget-raven-heading"
                          data-id="1e376d4f"
                          data-element_type="widget"
                          data-widget_type="raven-heading.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="raven-widget-wrapper">
                              <h4 className="raven-heading raven-heading-h4">
                                <span className="raven-heading-title ">
                                  Quick Link
                                </span>
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-744280d1 elementor-mobile-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                          data-id="744280d1"
                          data-element_type="widget"
                          data-widget_type="icon-list.default"
                        >
                          <div className="elementor-widget-container">
                            <link
                              rel="stylesheet"
                              href="https://haiico.com/wp-content/uploads/elementor/css/custom-widget-icon-list.min.css?ver=1698975480"
                            />{" "}
                            <ul className="elementor-icon-list-items">
                              <li className="elementor-icon-list-item">
                                <a
                                  href="https://haiico.com/community"
                                  target="_blank"
                                >
                                  <span className="elementor-icon-list-text">
                                    Community
                                  </span>
                                </a>
                              </li>
                              <li className="elementor-icon-list-item">
                                <a
                                  href="https://haiico.com/become-our-partner"
                                  target="_blank"
                                >
                                  <span className="elementor-icon-list-text">
                                    Become Our Partner
                                  </span>
                                </a>
                              </li>
                              <li className="elementor-icon-list-item">
                                <a
                                  href="https://haiico.com/become-our-partner/?pricing"
                                  target="_blank"
                                >
                                  <span className="elementor-icon-list-text">
                                    Pricing
                                  </span>
                                </a>
                              </li>
                              <li className="elementor-icon-list-item">
                                <a
                                  href="https://haiico.com/contact-us"
                                  target="_blank"
                                >
                                  <span className="elementor-icon-list-text">
                                    Contact Us
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-230a03b8"
                      data-id="230a03b8"
                      data-element_type="column"
                      id="fcol-support"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-d58d02c elementor-mobile-align-center elementor-align-left elementor-widget elementor-widget-raven-heading"
                          data-id="d58d02c"
                          data-element_type="widget"
                          data-widget_type="raven-heading.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="raven-widget-wrapper">
                              <h4 className="raven-heading raven-heading-h4">
                                <span className="raven-heading-title ">
                                  Support
                                </span>
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-ba0ea09 elementor-mobile-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                          data-id="ba0ea09"
                          data-element_type="widget"
                          data-widget_type="icon-list.default"
                        >
                          <div className="elementor-widget-container">
                            <ul className="elementor-icon-list-items">
                              <li className="elementor-icon-list-item">
                                <a
                                  href="https://haiico.com/news-and-articles"
                                  target="_blank"
                                >
                                  <span className="elementor-icon-list-text">
                                    News & Articles
                                  </span>
                                </a>
                              </li>
                              <li className="elementor-icon-list-item">
                                <a
                                  href="https://haiico.com/faqs"
                                  target="_blank"
                                >
                                  <span className="elementor-icon-list-text">
                                    FAQs
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-1392ef3d"
                      data-id="1392ef3d"
                      data-element_type="column"
                      id="fcol-follow"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-5654985 elementor-mobile-align-center elementor-align-left elementor-widget elementor-widget-raven-heading"
                          data-id="5654985"
                          data-element_type="widget"
                          data-widget_type="raven-heading.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="raven-widget-wrapper">
                              <h4 className="raven-heading raven-heading-h4">
                                <span className="raven-heading-title ">
                                  Follow Us
                                </span>
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-8cc59aa elementor-align-left elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                          data-id="8cc59aa"
                          data-element_type="widget"
                          data-widget_type="icon-list.default"
                        >
                          <div className="elementor-widget-container">
                            <ul className="elementor-icon-list-items">
                              <li className="elementor-icon-list-item">
                                <a
                                  href="https://www.facebook.com/haiicoapp"
                                  target="_blank"
                                  rel="nofollow"
                                >
                                  <span className="elementor-icon-list-icon">
                                    <FacebookRoundedIcon className="fab fa-facebook" />
                                  </span>
                                  <span className="elementor-icon-list-text">
                                    Facebook
                                  </span>
                                </a>
                              </li>
                              <li className="elementor-icon-list-item">
                                <a
                                  href="https://www.instagram.com/haiico.app/"
                                  target="_blank"
                                  rel="nofollow"
                                >
                                  <span className="elementor-icon-list-icon">
                                    <InstagramIcon />
                                  </span>
                                  <span className="elementor-icon-list-text">
                                    Instagram
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-52882ddd elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="52882ddd"
                  data-element_type="section"
                  id="footer-bottom"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-74e1c11a"
                      data-id="74e1c11a"
                      data-element_type="column"
                      id="fcol-copyright"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-40020fe elementor-widget elementor-widget-html"
                          data-id="40020fe"
                          data-element_type="widget"
                          id="copyright"
                          data-widget_type="html.default"
                        >
                          <div className="elementor-widget-container">
                            Copyright 2023 © CardSys Sdn. Bhd. (407836-T).{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-66 elementor-inner-column elementor-element elementor-element-53a7e993"
                      data-id="53a7e993"
                      data-element_type="column"
                      id="fcol-legal"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-b3675ac elementor-icon-list--layout-inline elementor-align-right elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                          data-id="b3675ac"
                          data-element_type="widget"
                          data-widget_type="icon-list.default"
                        >
                          <div className="elementor-widget-container">
                            <ul className="elementor-icon-list-items elementor-inline-items">
                              <li className="elementor-icon-list-item elementor-inline-item">
                                <a
                                  href="https://haiico.com/terms-and-conditions/?user"
                                  target="_blank"
                                >
                                  <span className="elementor-icon-list-text">
                                    Terms & Conditions (User)
                                  </span>
                                </a>
                              </li>
                              <li className="elementor-icon-list-item elementor-inline-item">
                                <a
                                  href="https://haiico.com/terms-and-conditions/?partners"
                                  target="_blank"
                                >
                                  <span className="elementor-icon-list-text">
                                    Terms & Conditions (Partners)
                                  </span>
                                </a>
                              </li>
                              <li className="elementor-icon-list-item elementor-inline-item">
                                <a
                                  href="https://haiico.com/privacy-policy"
                                  target="_blank"
                                >
                                  <span className="elementor-icon-list-text">
                                    Privacy Policy
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>
    </footer>
  );
};

export default footer;
